/**
 * Routes that do not require authentication.
 * Used by App.js (loading screen bypass) and restoreAuthSession (refresh skip).
 */
export const PUBLIC_PATHS = [
  '/signin',
  '/login',
  '/reset-password',
  '/set-password',
  '/verify',
  '/terms',
  '/mobile-verify',
  '/authentication-page',
]

export const isPublicPath = (pathname) =>
  PUBLIC_PATHS.some(path => pathname.startsWith(path))
